'use strict';

var abstractMatrix = require('../abstractMatrix');
var Matrix = require('../matrix');

class BaseView extends abstractMatrix() {
    constructor(matrix, rows, columns) {
        super();
        this.matrix = matrix;
        this.rows = rows;
        this.columns = columns;
    }

    static get [Symbol.species]() {
        return Matrix.Matrix;
    }
}

module.exports = BaseView;



//////////////////
// WEBPACK FOOTER
// ./~/ml-fnn/~/ml-matrix/src/views/base.js
// module id = 15
// module chunks = 0